module.exports = __webpack_public_path__ + "static/media/alert-circular-icon.ef927f7f.svg";